export default __webpack_public_path__ + "static/media/cover_area_bg.a0d5e3ce.png";